import React from 'react';

/** Индикатор ожидания ответа в текстовом чате */
const ThinkingIndicator = () => (
    <div className="bananas-thinking flex items-center gap-2.5 px-1 py-2" role="status" aria-live="polite">
        <span className="bananas-thinking-dots" aria-hidden>
            <span />
            <span />
            <span />
        </span>
        <span className="bananas-thinking-label bananas-msg-font">Думаю…</span>
    </div>
);

export default ThinkingIndicator;
